module.exports = __webpack_public_path__ + "static/hero-sourcing-321768839cbd88ad680b6eaab771aa00.svg";